import { Doctor } from "types/doctor";
import { VEHDisplayName } from "features/scheduling/utils/vehDisplayName";

const getDocSuffix = (providerSuffix: string | undefined) => {
  return providerSuffix ? ", " + providerSuffix : "";
};
export const doctorFullName = (
  doctor: Doctor,
  namechangeVEH?: boolean
): string =>
  doctor.firstName &&
  doctor.firstName.toLowerCase().includes("open network") &&
  namechangeVEH
    ? VEHDisplayName()
    : doctor.firstName &&
      doctor.firstName.toLowerCase().includes("open network")
    ? VEHDisplayName()
    : `${doctor.firstName} ${doctor.lastName}${getDocSuffix(
        doctor.providerSuffix
      )}`;

export const doctorFullNameVEH = (
  doctor: Doctor,
  namechangeVEH: boolean
): string =>
  doctor.firstName && doctor.firstName.toLowerCase().includes("open network")
    ? namechangeVEH
      ? VEHDisplayName()
      : VEHDisplayName()
    : `${doctor.firstName} ${doctor.lastName}${getDocSuffix(
        doctor.providerSuffix
      )}`;

declare let discountVEHDoctor: string;

export const doctorDiscountNameVEH = (): string => {
  discountVEHDoctor =
    typeof discountVEHDoctor !== "undefined" ? discountVEHDoctor : "";
  return discountVEHDoctor;
};
